<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left {{ content.emphasis ? 'colorize text-' + content.emphasis : '' }}">
      {{ content.title }}
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [innerHTML]="content.content"></div>
  <div class="modal-footer" *ngIf="content.closeBtn">
    <button class="btn btn-secondary" (click)="modalRef.hide()">{{ content.closeBtn }}</button>
  </div>
</ng-template>
